import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Stepper, Step, StepLabel, Button, RadioGroup, FormControlLabel, Radio, CircularProgress } from '@material-ui/core';
import Client from '../components/Client';
import CaseType from './CaseType'
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http';
import { roleStr, ADD, EDIT, VIEW } from '../../../common/common';
import Toast from '../../Layout/components/Toast';
import ClientAutoComplete from '../../Components/ClientAutoComplete';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .existedClient': {
        width: '100%',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
    '& .progressWapper': {
        width: '100%',
        paddingBottom: '80px',
    },
    '& .completeTitle': {
        color: '#0064C2',
        marginTop: '36px',
        marginBottom: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .completeDet': {
        color: '#CCCCCC',
        marginBottom: '80px',
        fontSize: '16px',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    }
})

const EXISTED = "existed";
const NEW = "new";
const AUDITED = "audited";
class CaseInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            steps: [
                'Fill in the Client Info',
                'Fill in the Case Info',
                'Completion'
            ],
            case_id: "",
            radioValue: EXISTED,
            clientObj: null,
            client_id: "",
            clients: [],

            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.updateTempBy = this.updateTempBy.bind(this);
    }
    render() {
        const { title, data, state } = this.props;
        const { activeStep,
            steps,
            radioValue,
            clientObj,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const stepInfo = () => {
            if (state === ADD) {
                if (activeStep === 0) {//step1
                    return <div>
                        <RadioGroup
                            aria-label="Gender"
                            name="gender1"
                            row
                            value={radioValue}
                            onChange={this.handleRadio}
                        >
                            <FormControlLabel value={EXISTED} control={<Radio color="primary" />} label="Existed Client" />
                            <FormControlLabel value={NEW} control={<Radio color="primary" />} label="New Client" />
                        </RadioGroup>
                        <div className="textWapper">
                            {clientInfo()}
                        </div>
                    </div>
                } else if (activeStep === 1) {//step2
                    return <CaseType
                        ref={(child) => { this.casetype = child }}
                        data={data}
                        state={state}
                    ></CaseType>
                } else if (activeStep === 2) {//step3
                    return <div className="progressWapper c">
                        <CircularProgress />
                    </div>
                } else if (activeStep === 3) {//complete
                    return <div className="c">
                        <div className="completeTitle">YOU SUCCESSFULLY CREATED A CASE!</div>
                        <div className="completeDet">(You can view or edit the case info through case list)</div>
                    </div>
                }
            } else if (state === VIEW) {
                if (activeStep === 0) {//step1
                    return <div className="textWapper">
                        {clientInfo()}
                    </div>
                } else if (activeStep === 1) {//step2
                    return <CaseType
                        ref={(child) => { this.casetype = child }}
                        data={data}
                        state={state}
                    ></CaseType>
                } else if (activeStep === 2) {//step3
                    return <div className="progressWapper c">
                        <CircularProgress />
                    </div>
                } else if (activeStep === 3) {//complete
                    return <div className="c">
                        <div className="completeTitle">YOU SUCCESSFULLY CREATED A CASE!</div>
                        <div className="completeDet">(You can view or edit the case info through case list)</div>
                    </div>
                }
            } else if (state === EDIT) {
                if (activeStep === 0) {//step1
                    return <div>
                        <div className="title">Already Existed Client</div>
                        <div className="textWapper">
                            {clientInfo()}
                        </div>
                    </div>
                } else if (activeStep === 1) {//step2
                    return <CaseType
                        ref={(child) => { this.casetype = child }}
                        data={data}
                        state={state}
                    ></CaseType>
                } else if (activeStep === 2) {//step3
                    return <div className="progressWapper c">
                        <CircularProgress />
                    </div>
                } else if (activeStep === 3) {//complete
                    return <div className="c">
                        <div className="completeTitle">YOU SUCCESSFULLY EDIT A CASE!</div>
                        <div className="completeDet">(You can view or edit the case info through case list)</div>
                    </div>
                }
            }
        }
        const clientInfo = () => {
            if (state === ADD || state === EDIT) {
                if (radioValue === EXISTED) {
                    // return <TextField
                    //     disabled={this.isDisabled()}
                    //     id="attorney"
                    //     select
                    //     label="Choose the Existed Client (Name / Email / Phone)"
                    //     className="existedClient"
                    //     value={client_id}
                    //     onChange={e => this.handleSelect(e, "client_id")}
                    //     margin="dense"
                    //     variant="outlined"
                    // >
                    //     {clients.map(option => (
                    //         <MenuItem key={option.id} value={option.id}>
                    //             {option.individual ?
                    //                 option.individual.first_name + option.individual.last_name + " / " + option.individual.email + " / " + option.individual.phone :
                    //                 option.corporation.name}
                    //         </MenuItem>
                    //     ))}
                    // </TextField>
                    return <ClientAutoComplete
                        allClient={true}
                        initClient={clientObj}
                        update={this.updateTempBy}
                    />
                } else if (radioValue === NEW) {
                    return <Client
                        ref={(child) => { this.client = child }}
                        data={data}
                        state={state}
                    ></Client>
                }
            } else if (state === VIEW) {
                if (data) {
                    return <Client
                        ref={(child) => { this.client = child }}
                        data={data.client}
                        state={state}
                    ></Client>
                }
            }
        }
        const btns = () => {
            if (state === ADD) {
                if (activeStep >= 3) {
                    return <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleClose}
                    >
                        CLOSE
                    </Button>
                } else {
                    return <div>
                        <Button
                            disabled={activeStep === 0 || activeStep >= 2}
                            onClick={this.handleBack}
                        >
                            PREVIOUS
                        </Button>
                        <Button
                            disabled={activeStep >= 2}
                            variant="contained"
                            color="primary"
                            onClick={this.handleNext}>
                            {activeStep >= steps.length - 2 ? 'CREATE' : 'NEXT'}
                        </Button>
                    </div>
                }
            } else if (state === VIEW) {
                return <div>
                    <Button
                        disabled={activeStep === 0}
                        onClick={this.handleBack}
                    >
                        PREVIOUS
                        </Button>
                    <Button
                        disabled={activeStep >= 2}
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}>
                        {activeStep >= steps.length - 1 ? 'CANCEL' : 'NEXT'}
                    </Button>
                </div>
            } else if (state === EDIT) {
                if (activeStep >= 3) {
                    return <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleClose}
                    >
                        CLOSE
                    </Button>
                } else {
                    return <div>
                        <Button
                            disabled={activeStep === 0 || activeStep >= 2}
                            onClick={this.handleBack}
                        >
                            PREVIOUS
                        </Button>
                        <Button
                            disabled={activeStep >= 2}
                            variant="contained"
                            color="primary"
                            onClick={this.handleNext}>
                            {activeStep >= steps.length - 2 ? 'SAVE' : 'NEXT'}
                        </Button>
                    </div>
                }
            }
        }
        return (
            <Root>
                <div className="pageTitle">{title}</div>
                <div className="line"></div>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map(label => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                {stepInfo()}
                <div className="line"></div>
                <div className="foot h h-bt">
                    <Button className="btn" variant="contained" onClick={this.handleClose}>CANCEL</Button>
                    {btns()}
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        const { data } = this.props;
        console.log("=======", data)
        this.getClients(() => {
            this.initData();
        });
    }
    initData() {
        const { state, data } = this.props;
        const steps = [
            'Fill in the Client Info',
            'Fill in the Case Info',
        ];
        if (state === VIEW) {
            this.setState(() => ({
                steps
            }))
        } else if (state === EDIT) {
            this.setState(() => ({
                clientObj: data.client,
                client_id: data.client.id,
                case_id: data.id
            }))
        }
    }
    handleNext() {
        const { activeStep } = this.state;
        const { state } = this.props;
        if (state === ADD || state === EDIT) {
            if (activeStep === 0) {//第一步
                if (!this.checkStep1()) return;
            } else if (activeStep === 1) {//第二步
                if (!this.checkStep2()) {
                    return;
                } else {
                    this.createCase();
                }
            }
        } else if (state === VIEW) {
            if (activeStep >= 1) {
                this.props.handleCloseDialog();
                return;
            }
        }
        this.nextStep();
    }

    handleBack() {
        const { activeStep } = this.state;
        let prevActiveStep = activeStep;
        this.setState(() => ({
            activeStep: prevActiveStep - 1
        }))
    }

    handleRadio(e) {
        let radioValue = e.target.value;
        this.setState(() => ({
            radioValue
        }))
    }

    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleClose() {
        this.props.handleCloseDialog();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    updateTempBy(clientObj) {
        if (clientObj) {
            this.setState(() => ({
                client_id: clientObj.id,
                clientObj
            }))
        }
    }
    nextStep() {
        const { activeStep } = this.state;
        const nextStep = activeStep + 1;
        this.setState(() => ({
            activeStep: nextStep
        }))
        console.log("-------nextStep------", nextStep)
    }

    //检查第一步条件
    checkStep1() {
        const { radioValue, client_id } = this.state;
        if (radioValue === EXISTED) {
            this.isNewClient = false;
            if (!client_id) {
                this.showToast("Please select a client", "warning");
                return false;
            }
        } else if (radioValue === NEW) {
            this.isNewClient = true;
            const clientData = this.client.getData();
            this.clientData = clientData;
            if (!clientData) {
                this.showToast("Please fill in the client information", "warning");
                return false;
            }
        } else {
            this.isNewClient = false;
            return false;
        }
        return true;
    }
    //检查第二步条件
    checkStep2() {
        const { state } = this.props;
        const data = this.casetype.getData();
        this.casetypeData = data;
        const number = data.number;
        const department_id = data.department_id;
        const addMembers = data.handlers.addMembers ? data.handlers.addMembers : [];
        let isPass = true;
        if (state === ADD) {
            if (!number) {
                this.showToast("Please fill in the case number", "warning");
                isPass = false;
            } else if (addMembers.length > 0) {
                const handler_id = addMembers[0].handler_id;
                if (!handler_id || !department_id) {
                    let toastText = "";
                    if (!department_id) toastText = "Please fill in the department";
                    if (!handler_id) toastText = "Please choose an attorney";
                    this.showToast(toastText, "warning");
                    isPass = false;
                }
            } else if (addMembers.length <= 0) {
                this.showToast("Please choose an attorney", "warning");
                isPass = false;
            }
        } else if (state === EDIT) {
            if (number === "") {
                this.showToast("Please fill in the case number", "warning");
                isPass = false;
            }else if (addMembers.length > 0) {
                const handler_id = addMembers[0].handler_id;
                if (!handler_id) {
                    this.showToast("Please choose an attorney", "warning");
                    isPass = false;
                }
            }
        }
        return isPass;
    }
    //1.检查client是否是新建
    //是：调用client创建接口->返回clientid
    //2.检查case type是否是新建
    //是：调用type创建接口->返回typeid
    //3.取得clientid和typeid 创建case
    createCase() {
        const {
            client_id,
            case_id
        } = this.state;
        const isNewClient = this.isNewClient;
        const casetypeData = this.casetypeData;
        const number = casetypeData.number;
        const handlers = casetypeData.handlers;
        const notes = casetypeData.notes;
        const department_id = casetypeData.department_id;
        if (isNewClient) {//client新增
            this.createClient((client_id) => {
                this.addOrUpdateCase(case_id, number, department_id, notes, client_id, handlers);
            })
        } else {//client不新增
            this.addOrUpdateCase(case_id, number, department_id, notes, client_id, handlers);
        }
    }
    addOrUpdateCase(case_id, number, department_id, notes, client_id, handlers) {
        const { state } = this.props;
        if (state === ADD) {
            this.addCase(number, department_id, notes, client_id, handlers);
        } else if (state === EDIT) {
            this.updateCase(case_id, number, department_id, notes, client_id, handlers);
        }
    }
    createClient(callback) {
        const clientData = this.clientData;
        if (clientData.type === "individual") {
            this.addIndividual(clientData.data, (res) => {
                const client_id = res.data.data.id;
                callback(client_id);
            });
        } else if (clientData.type === "corporation") {
            this.addCorporation(clientData.data, (res) => {
                const client_id = res.data.data.id;
                callback(client_id);
            });
        }
    }
    isDisabled() {
        const { state, data } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW || !data.editable) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    getObjByName(objArr, key, value) {
        return objArr.find((element) => (element[key] === value));
    }
    attorneyInfo(handlerArr, type) {
        if (handlerArr) {
            let attorneyObj = {};
            for (const obj of handlerArr) {
                if (obj.is_origin_attorney) {
                    attorneyObj = obj;
                }
            }
            if (attorneyObj) {
                if (type === "name") {
                    const userObj = attorneyObj.user;
                    return userObj.first_name + " " + userObj.last_name;
                } else if (type === "team") {
                    const teamObj = attorneyObj.team;
                    return teamObj.name;
                }
            }
        }
        return "--"
    }
    //------------request-----------------
    getClients(callback) {
        const { clients } = this.state;
        const params = {
            page_index: 1,
            page_size: 1000
        }
        instance.get(BASE_URL + roleStr() + '/clients', { params }).then((res) => {
            let clientsCopy = clients;
            for (let obj of res.data.data) {
                clientsCopy.push(obj)
            }
            this.setState({
                clients: clientsCopy
            }, () => {
                this.getCClient(() => {
                    callback();
                });
            })
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    getCClient(callback) {
        const { clients } = this.state;
        const params = {
            target: "corp",
            page_index: 1,
            page_size: 1000
        }
        instance.get(BASE_URL + roleStr() + '/clients', { params }).then((res) => {
            let clientsCopy = clients;
            for (let obj of res.data.data) {
                clientsCopy.push(obj)
            }
            this.setState({
                clients: clientsCopy
            }, () => {
                callback();
            })
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    addCase(number, department_id, notes, client_id, handlers) {
        const params = {
            number,
            department_id,
            notes,
            client_id,
            handlers: handlers.addMembers
        }
        console.log(params)
        instance.post(BASE_URL + roleStr() + '/cases', params).then((res) => {
            console.log("createcase", res)
            // this.showToast("Added successfully", "success");
            this.nextStep();
        }).catch((err) => {
            const errCode = err.response.status;
            if (errCode === 400) {
                this.showToast("Duplicate case number", "error");
            }
        })
    }
    updateCase(case_id, number, department_id, notes, client_id, handlers) {
        const params = {
            // number: (this.props.state !== EDIT) ? number : null,
            number,
            department_id,
            notes,
            client_id,
        }
        instance.put(BASE_URL + roleStr() + '/cases/' + case_id, params).then((res) => {
            console.log("updatecase", res)
            this.editHandlers(case_id, handlers, () => {
                this.nextStep();
            });
            // this.showToast("Successfully modified", "success");
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    editHandlers(case_id, membersObj, callback) {
        const addMembers = membersObj.addMembers;
        const delMembers = membersObj.delMembers;
        const addIndex = addMembers.length;
        const delIndex = delMembers.length;
        if (addIndex <= 0 && delIndex <= 0) {
            callback();
        } else if (addIndex > 0 && delIndex > 0) {
            this.addMembers(case_id, addMembers, () => {
                this.delMembers(case_id, delMembers, () => {
                    callback();
                });
            });
        } else if (addIndex > 0) {
            this.addMembers(case_id, addMembers, () => {
                callback();
            });
        } else if (delIndex > 0) {
            this.delMembers(case_id, delMembers, () => {
                callback();
            });
        }
    }
    addIndividual(obj, callback) {
        const params = {
            first_name: obj.first_name,
            last_name: obj.last_name,
            email: obj.email,
            phone: obj.phone,
            wechat: obj.wechat,
            referral_source: obj.referral_source,
            related_parties: obj.related_parties,
            note: obj.note,
            handler_id: obj.handler_id,
            handler_team_id: obj.handler_team_id,
        }
        instance.post(BASE_URL + roleStr() + '/clients/individual', params).then((res) => {
            this.showToast("Added successfully", "success");
            const id = res.data.data.id;
            this.iApproval(id);
            callback(res);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    addCorporation(obj, callback) {
        const params = {
            name: obj.name,
            referral_source: obj.referral_source,
            address: obj.address,
            points_of_contact: obj.points_of_contact,
            related_parties: obj.related_parties,
            note: obj.note,
            members: obj.members,
            handler_id: obj.handler_id,
            handler_team_id: obj.handler_team_id,
        }
        instance.post(BASE_URL + roleStr() + '/clients/corporation', params).then((res) => {
            this.showToast("Added successfully", "success");
            const id = res.data.data.id;
            this.cApproval(id);
            callback(res);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    iApproval(client_id) {
        const params = {
            state: AUDITED,
        }
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/individual', params).then((res) => {
            console.log("审核", res)
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    cApproval(client_id) {
        const params = {
            state: AUDITED,
        }
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/corporation', params).then((res) => {
            console.log(res)
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    addMembers(case_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.post(BASE_URL + roleStr() + '/cases/' + case_id + '/handlers', params).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delMembers(case_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.delete(BASE_URL + roleStr() + '/cases/' + case_id + '/handlers', { data: params }).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default CaseInfo;